<template>
  <v-card class="d-flex">
    <v-card-text>
<!--      <pre>{{ query }}</pre>-->
<!--      <pre>{{ offer }}</pre>-->
      <div><b>Denumire furnizor:</b> <a :href="offer.url" class="ml-2">{{ offer.furnizor.nume_furnizor }}</a></div>
      <div><b>Denumire oferta-tip:</b> <a :href="offer.url_oferta" class="ml-2">{{ offer.nume_oferta }}</a></div>
      <div><b>Preţ gaze naturale (lei/MWh):</b> {{ offer.pg }}</div>
      <div><b>Cost de transport (lei/MWh):</b> {{ offer.tt }}</div>
      <div><b>Tarif de distribuţie (lei/MWh):</b> {{ offer.t0 }}</div>
      <div><b>*Preţ de furnizare (lei/MWh):</b> {{ pret_furnizare_mwh.toFixed(4) }}</div>
      <div><b>*Preţ de furnizare (lei/KWh):</b> {{ pret_furnizare_kwh.toFixed(4) }}</div>
      <div><b>Valoare Componentă fixă (abonament) (lei/zi):</b> {{ offer.cf || 0 }}</div>
      <div><b>** Rezultat comparație preţ oferta-tip/preţ actual (%):</b> <span :class="`${rezultat_comparatie_color}--text`">{{ rezultat_comparatie }}</span></div>
      <div><b>** Valoare factură estimată conform ofertei-tip (cu TVA, si acciza, după caz) (lei):</b> {{ valoare_factura_estimata }}</div>
      <div><b>Economie/Cost suplimentar lunar (lei):</b> <span :class="`${economie_sau_cost_color}--text`">{{ economie_sau_cost }}</span></div>
      <div><i>* valoare cu acciza si TVA</i></div>
      <div><i>** include si valoarea abonamentului lunar</i></div>
      <v-expansion-panel class="mt-2">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Vezi detalii</div>
          </template>
          <v-card>
            <v-card-text>
              <div><b>Denumirea ofertei-tip:</b> <a :href="offer.url_oferta" class="ml-2">{{ offer.nume_oferta }}</a></div>
              <div><b>Tipul ofertei:</b> {{ offer.tip_oferta }}</div>
              <div><b>Valabilitate oferta:</b> {{ perioada_oferta }}</div>
              <div><b>Tip client:</b> {{ offer.tip_client }}</div>
              <div><b>Modalitate de racordare:</b> {{ offer.mod_racordare }}</div>
              <div><b>Categoria de consum:</b> {{ offer.categorie_client }}</div>
              <div><b>Servicii reglementate incluse în preţ:</b> {{ offer.servicii_de_reglementare_incluse }}</div>
              <div><b>Ultima actualizare:</b> {{ offer.ultima_actualizare }}</div>
              <div><b>Model contract:</b> <a :href="model_contract" title="Descarca" class="ml-2">Descarca</a></div>
              <v-divider class="mt-4 mb-4"/>
              <div><b>Durata contractului:</b> {{ offer.durata_contract }}</div>
              <div><b>Garantii:</b> {{ offer.garantii }}</div>
              <div><b>Frecventa emitere factura:</b> {{ offer.frecventa_emitere_factura }}</div>
              <div><b>Termen de plata:</b> {{ offer.termen_plata }}</div>
              <div><b>Mod transmitere factură:</b> {{ offer.mod_transmitere_factura }}</div>
              <div><b>Mod transmitere documente pentru incheiere contract:</b> </div>
              <div><b>Reduceri oferite:</b> {{ offer.reduceri_oferite }}</div>
              <div><b>Durata aplicare reducere:</b> {{ durata_reduceri_oferite }}</div>
              <v-divider class="mt-4 mb-4"/>
              <div><b>Structura pretului din oferta tip:</b></div>
              <div><b>Pret furnizare {{ pret_de_furnizare.toFixed(2) }}, din care:</b></div>
              <div> - Preţ gaze naturale (lei/MWh): {{ offer.pg }}</div>
              <div> - Cost de transport: {{ offer.tt }}</div>
              <div> - Tarif de distributie: {{ offer.t0 }}</div>
              <div> - Acciza: {{ offer.acciza }}</div>
              <div> - TVA ({{ offer.tva }}%): {{ tva_pret_de_furnizare.toFixed(2) }}</div>
              <div><b>Valoare componenta fixa(abonament) (lei/zi):</b> {{ offer.cf || 0 }}</div>
              <div><b>Tip pret gaze naturale:</b> {{ offer.tip_pret }}</div>
              <div><b>Perioada de aplicare a pretului gazelor naturale dupa incheierea contractului aferent ofertei:</b> {{ offer.perioada_aplicare_pret }}</div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mt-2">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Informatii contractare</div>
          </template>
          <v-card>
            <v-card-text>
              <template v-for="grup_documente in documente_grupate">
                <h3 class="mb-2 mt-2">{{ grup_documente.label }}</h3>
                <template v-for="document in grup_documente.items">
                  <div v-if="document.fisier" :key="document.id_document">
                    <a :href="`https://posf.ro/comparator/files/contracte/${document.fisier}`" class="mr-2">Descarca</a> {{ document.nume }}
                  </div>
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import langs from '../../modules/gaz/lang/index';
export default {
  props: {
    offer: Object,
    query: Object
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    tva_pret_de_furnizare () {
      return this.pret_de_furnizare_fara_tva * this.offer.tva / 100
    },
    pret_de_furnizare_fara_tva () {
      return (parseFloat(this.offer.pg) +
        parseFloat(this.offer.tt) +
        parseFloat(this.offer.t0) +
        parseFloat(this.offer.acciza));
    },
    pret_de_furnizare() {
      return this.pret_de_furnizare_fara_tva + this.tva_pret_de_furnizare;
    },
    model_contract () {
      const baseUrl = 'https://posf.ro/comparator/files/furnizori_gaz/'
      return this.offer.model_contract.length > 0 ? `${baseUrl}/${this.offer.model_contract[0]}` : '#'
    },
    durata_reduceri_oferite () {
      if (
        this.offer.durata_reduceri_oferite_min === '01.01.1970' ||
        this.offer.durata_reduceri_oferite_max === '01.01.1970'
      ) {
        return 'Nu este cazul'
      }
      if (!this.offer.durata_reduceri_oferite_min || !this.offer.durata_reduceri_oferite_max) {
        return '';
      }
      return `${this.offer.durata_reduceri_oferite_min} - ${this.offer.durata_reduceri_oferite_max}`
    },
    perioada_oferta () {
      if (!this.offer.perioada_oferta_min || !this.offer.perioada_oferta_max) {
        return '';
      }
      return `${this.offer.perioada_oferta_min} - ${this.offer.perioada_oferta_max}`
    },
    rezultat_comparatie () {
      const lang = langs[this.language];
      return this.query.consum_mwh ? this.offer.rezultat_comparatie : lang.introduceti_pretul_actual
    },
    rezultat_comparatie_color () {
      return this.rezultat_comparatie <= 0 ? 'green' : 'red'
    },
    economie_sau_cost () {
      const lang = langs[this.language];
      return this.query.pret_furnizare_mwh ? this.offer.economie_sau_cost : lang.introduceti_datele
    },
    economie_sau_cost_color () {
      return this.economie_sau_cost.indexOf('-') !== -1 ? 'green' : 'red'
    },
    pret_furnizare_mwh () {
      return this.pret_de_furnizare
    },
    pret_furnizare_kwh () {
      return this.pret_de_furnizare / 1000
    },
    valoare_factura_estimata () {
      const lang = langs[this.language];
      return this.query.consum_mwh
        ? (this.pret_de_furnizare * this.query.consum_mwh).toFixed(2)
        : lang.introduceti_consumul_estimat
    },
    documente_grupate () {
      const lang = langs[this.language];
      const documente_grupate = {
        client_nou: {
          label: lang.documente_client_nou_label,
          items: []
        },
        client_furnizor_existent: {
          label: lang.documente_client_furnizor_existent,
          items: []
        },
        client_furnizor_nou: {
          label: lang.documente_client_furnizor_nou,
          items: []
        },
      };
      const documente = this.offer.documente.filter(doc => doc.fisier && doc.tip_document);
      for (const document of documente) {
        if (document.tip_document.indexOf('client_nou') === 0) {
          documente_grupate.client_nou.items.push(document);
        } else if (document.tip_document.indexOf('client_furnizor_existent') === 0) {
          documente_grupate.client_furnizor_existent.items.push(document);
        } else if (document.tip_document.indexOf('client_furnizor_nou') === 0) {
          documente_grupate.client_furnizor_nou.items.push(document);
        } else if (document.tip_document.indexOf('model_contract') === 0) {
          // whatever
        } else {
          console.log(`Unable to classify document for ${this.offer.nume_oferta}: ${document.nume} (${document.tip_document})`);
        }
      }
      return documente_grupate;
    }
  }
}
</script>
